import React from "react";
import { Button, Card, Carousel, Modal, Stack } from "react-bootstrap";
import Select from "react-select";
import { ConsultaModal } from "./ConsultaModal";
import { history, TIPO_CONVERSACION } from "../../../_helpers";
import { faTh, faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
  ImageWithZoom,
} from "pure-react-carousel";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import imageService from "../../../_services/cart/image.service";

class CarrouselImages extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    appName: process.env.PUBLIC_URL,
    showImage: false
  };

  handleClose = () => {
    this.setState({ showImage: false });
  }

  abrirImage = () => {

    if(this.props.esProductDetail){
      this.setState({ showImage: true });
    }

    
  }

  render() {

    const {images, esListador, esProductDetail} = this.props;

    const defaultImage = {url: this.state.appName + "/images/banner-bg.jpg", type:'image/jpeg'};

    const imagesChanged = images.filter(it=>imageService.isImage(it)).map(it=>({original: it.url, thumbnail: it.url, type: it.type}))

    return (
      <>
        <CarouselProvider
          className="mb-6"
          interval={1000}
          //naturalSlideWidth={150}
          // naturalSlideHeight={250}
          visibleSlides={1}
          infinite={true}
          lockOnWindowScroll={true}

          totalSlides={images.length}
          isIntrinsicHeight={true}
        >
          <Slider className="slider" >
          {images.map((img, index) =>
          
            <Slide className="slide" key={index} index={index} >
              {imageService.isImage(img)?
              <img className="d-block" src={img.url} alt={img.tipo} onClick={()=>this.abrirImage()}/>:
              <video controls={true} className='w-100' src={img.url}> </video>   
            }             
            </Slide>
          )}

          </Slider>

         {esProductDetail &&
         <>
         <div className="slider_buttons">
          <div className="slider_buttons-dot">
          <DotGroup className="dotGroup" />
          </div>
          <div className="slider_buttons-btn">
            <ButtonBack className="button" data-type="arrows">
              <span>
                <FontAwesomeIcon icon="fa-solid fa-chevron-left" size="xl" />
              </span>
            </ButtonBack>
            <ButtonNext className="button" data-type="arrows">
              <span>
                <FontAwesomeIcon icon="fa-solid fa-chevron-right" size="xl" />
              </span>
            </ButtonNext>
            </div>
          </div>
          </>}
        </CarouselProvider>

            <Modal fullscreen={true} show={this.state.showImage} onHide={this.handleClose}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <ImageGallery 
                   renderItem={ (image) => 
                         <Zoom>
                           <img className="image-gallery-image"  src={image.original}/>
                         </Zoom>
                   } 
                  items={imagesChanged} />
                 
                </Modal.Body>
            </Modal>
      </>
    );
  }
}

export default CarrouselImages;
